import {Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges} from '@angular/core';
import { NewsType } from 'src/app/models/enums/newsType';
import { NewsModel } from 'src/app/models/NewsModel';
import { Router } from '@angular/router';
import { ConstantsStore } from 'src/app/core/services/constants.store';
import { NewsStore } from 'src/app/core/services/news/news.store';

@Component({
  selector: 'app-news-slide',
  templateUrl: './news-slide.component.html',
  styleUrls: ['./news-slide.component.scss']
})
export class NewsTableComponent implements OnInit {

  @Input() newsList: NewsModel[];

  newsTypeEnum = NewsType;
  selectedNewsId: number;

  constructor(private router: Router, private constantsStore: ConstantsStore, private store: NewsStore) {
  }

  ngOnInit(): void {
    this.selectedNewsId = this.newsList[0]?.id;
  }

  setSelectedNewsId(news: NewsModel) {
    this.selectedNewsId = news.id;
  }

  getHeaders(news: any): string[] {
    const headers: string[] = [];
    if (news.newsRecords[0]) {
    news.newsRecords[0].newsRecordsData.forEach(d => headers.push(d.dataHeader));
    }
    return headers;
  }

  getTableRecords(news: any): Record[] {
    const records: Record[] = [];
    news.newsRecords.forEach(record => records.push(this.getRecord(record)));
    return records;
  }

  getRecord(record: any): Record {
    const recordView: Record = {
      recordValues: [],
      description: ''
    };
    record.newsRecordsData.forEach(d => recordView.recordValues.push(d.dataValue));
    recordView.description = record.description;
    return recordView;
  }

  getCompleteImageUrl(news: NewsModel) {
    if (news) {
      const completeImageUrl = this.constantsStore.apiUrl + '/' + news.newsRecords[0].imagePath;
      return completeImageUrl;
    }
  }

  newsTextPreview(news: NewsModel) {
    if (news) {
      const text = news.newsRecords[0].description;
      return (text.length > 160 ? text.substring(0, 160) + '...' : text);
    }
  }

  goToLink(news: NewsModel) {
    if (news && news.newsRecords[0].imageUrl) {
      this.router.navigateByUrl(news.newsRecords[0].imageUrl);
    }
  }

  goToArticle(news: NewsModel) {
    const myurl = '/menu/article?id=' + news.id;
    this.router.navigateByUrl(myurl);
  }

  goToNextSlide() {
    if (this.selectedNewsId) {
      const currentNews = this.newsList.filter(news => news.id === this.selectedNewsId)[0];
      const nextNewsId = this.newsList.indexOf(currentNews) + 1;
      if (nextNewsId < this.newsList.length) {
        this.selectedNewsId = this.newsList[nextNewsId].id;
      }
    }
  }

  goToPreviousSlide() {
    if (this.selectedNewsId) {
      const currentNews = this.newsList.filter(news => news.id === this.selectedNewsId)[0];
      const previousNewsId = this.newsList.indexOf(currentNews) - 1;
      if (previousNewsId > 0) {
        this.selectedNewsId = this.newsList[previousNewsId].id;
      }
    }
  }
}

export interface Record {
  recordValues: string[];
  description: string;
}
